module.exports = __webpack_public_path__ + "static/img/6.acf685a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/6.png
// module id = TCO7
// module chunks = 0